export default __webpack_public_path__ + "static/logo-black-3-8a37e75ebc5536a2bc84c5a46d61dd50.svg";